export enum BenefitProgram {
  FriendsAndFamily = 'friendsAndFamily',
  Kameleon = 'kameleon',
  MilesAndMore = 'milesAndMore'
}
